// Central site settings — edit business details here once and they update everywhere.
export const site = {
  name: "My Blinds Company",
  legalName: "My Blinds Company Ltd",
  tagline: "Beautiful windows. Perfectly measured. Professionally fitted.",
  domain: "https://myblindscompany.co.uk",
  phone: {
    display: "07868 295300",
    href: "tel:+447868295300",
  },
  whatsapp: {
    display: "+44 7405 183067",
    href: "https://wa.me/447405183067",
  },
  email: "info@myblindscompany.co.uk",
  address: {
    line1: "Unit 13d, 47 Whitmore Road",
    line2: "Small Heath",
    city: "Birmingham",
    postcode: "B10 0NR",
  },
  hours: [
    { days: "Monday – Friday", time: "9:00am – 5:00pm" },
    { days: "Saturday", time: "By appointment" },
    { days: "Sunday", time: "Closed" },
  ],
  social: {
    facebook: "https://www.facebook.com/people/My-Blinds-Company/100082066748462/",
    instagram: "https://www.instagram.com/myblindscompany",
    tiktok: "https://www.tiktok.com/@myblindscompany",
    googleReviews: "https://share.google/JETfVrCuoNxgyYRY7",
  },
  // Owner-supplied Google rating. Add reviewCount (e.g. "47") when confirmed.
  google: {
    rating: "5.0",
    reviewCount: "187",
  },
  // Only business-approved claims appear here.
  trustClaims: [
    "Price Promise",
    "Made to Measure",
    "Professional Measuring & Fitting",
    "Fully Guaranteed",
  ],
  primaryCTA: "Book a Free Design Visit",
  // Current promotion — set enabled to false to switch it off site-wide.
  offer: {
    enabled: true,
    text: "10% Off Blinds & Shutters",
    cta: "Claim 10% Off & Book Your Free Measure",
  },
  analytics: {
    ga4: process.env.REACT_APP_GA4_ID || "",
    gtm: process.env.REACT_APP_GTM_ID || "",
    metaPixel: process.env.REACT_APP_META_PIXEL_ID || "",
    googleAds: process.env.REACT_APP_GOOGLE_ADS_ID || "",
  },
};

export const fullAddress = `${site.address.line1}, ${site.address.line2}, ${site.address.city}, ${site.address.postcode}`;
